export var popupCloseAnimateBasic = {
	none: { label: "None", value: "" },
	backOutDown: { label: "backOutDown", value: "backOutDown" },
	backOutLeft: { label: "backOutLeft", value: "backOutLeft" },
	backOutRight: {
		label: "backOutRight",
		value: "backOutRight",

	},
	backOutUp: { label: "backOutUp", value: "backOutUp" },
	bounceOut: { label: "bounceOut", value: "bounceOut" },
	bounceOutDown: {
		label: "bounceOutDown",
		value: "bounceOutDown",

	},
	bounceOutLeft: {
		label: "bounceOutLeft",
		value: "bounceOutLeft",

	},
	bounceOutRight: {
		label: "bounceOutRight",
		value: "bounceOutRight",

	},
	bounceOutUp: { label: "bounceOutUp", value: "bounceOutUp" },
	fadeOut: { label: "fadeOut", value: "fadeOut" },
	fadeOutDown: { label: "fadeOutDown", value: "fadeOutDown" },
	fadeOutDownBig: {
		label: "fadeOutDownBig",
		value: "fadeOutDownBig",

	},
	fadeOutLeft: { label: "fadeOutLeft", value: "fadeOutLeft" },
	fadeOutLeftBig: {
		label: "fadeOutLeftBig",
		value: "fadeOutLeftBig",

	},
	fadeOutRight: {
		label: "fadeOutRight",
		value: "fadeOutRight",

	},
	fadeOutRightBig: {
		label: "fadeOutRightBig",
		value: "fadeOutRightBig",

	},
	fadeOutUp: { label: "fadeOutUp", value: "fadeOutUp" },
	fadeOutUpBig: {
		label: "fadeOutUpBig",
		value: "fadeOutUpBig",

	},
	fadeOutTopLeft: {
		label: "fadeOutTopLeft",
		value: "fadeOutTopLeft",

	},
	fadeOutTopRight: {
		label: "fadeOutTopRight",
		value: "fadeOutTopRight",

	},
	fadeOutBottomRight: {
		label: "fadeOutBottomRight",
		value: "fadeOutBottomRight",

	},
	fadeOutBottomLeft: {
		label: "fadeOutBottomLeft",
		value: "fadeOutBottomLeft",

	},
	rotateOut: { label: "rotateOut", value: "rotateOut" },
	rotateOutDownLeft: {
		label: "rotateOutDownLeft",
		value: "rotateOutDownLeft",

	},
	rotateOutDownRight: {
		label: "rotateOutDownRight",
		value: "rotateOutDownRight",

	},
	rotateOutUpLeft: {
		label: "rotateOutUpLeft",
		value: "rotateOutUpLeft",

	},
	rotateOutUpRight: {
		label: "rotateOutUpRight",
		value: "rotateOutUpRight",

	},
	zoomOut: { label: "zoomOut", value: "zoomOut" },
	zoomOutDown: { label: "zoomOutDown", value: "zoomOutDown" },
	zoomOutLeft: { label: "zoomOutLeft", value: "zoomOutLeft" },
	zoomOutRight: {
		label: "zoomOutRight",
		value: "zoomOutRight",

	},
	zoomOutUp: { label: "zoomOutUp", value: "zoomOutUp" },
	slideOutDown: {
		label: "slideOutDown",
		value: "slideOutDown",

	},
	slideOutLeft: {
		label: "slideOutLeft",
		value: "slideOutLeft",

	},
	slideOutRight: {
		label: "slideOutRight",
		value: "slideOutRight",

	},
	slideOutUp: { label: "slideOutUp", value: "slideOutUp" },
};
